import styled from 'styled-components/macro';

const Cell = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  padding: 0 1.5rem;
`;

export default Cell;
